
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.532 16.595a2.803 2.803 0 00-1.73-3.427 2.8 2.8 0 00-1.122-.163h-3a2.801 2.801 0 00-2.518 3.59H16.58a5.67 5.67 0 00-5.66 5.66 1 1 0 00.225.631 1 1 0 00-.215.619v3.17H6a2 2 0 000 4h4.93v3.04a14.09 14.09 0 0014.08 14.08h9a14.098 14.098 0 0014.1-14.12v-3h4.9a2 2 0 000-4h-4.9v-3.17c0-.23-.08-.453-.224-.631a1 1 0 00.214-.619 5.671 5.671 0 00-5.66-5.66h-8.908zm-16.912 2a3.649 3.649 0 00-3.56 2.66H46a3.66 3.66 0 00-3.52-2.66H31.014a2.807 2.807 0 01-.334 0H16.62zm14.239-2a.816.816 0 00.443-.198.802.802 0 00-.29-1.36.801.801 0 00-.332-.032h-3a.8.8 0 000 1.59h3.179zM12.92 33.675v-9.17l33.17-.04v9.21A12.101 12.101 0 0134 45.755h-9a12.089 12.089 0 01-12.08-12.08z"}})])
          )
        }
      }
    